export const ASSET_LOAD_TIMEOUT_MS = 12_000
export const ASSET_REFRESH_QUERY = '__ncg_refresh'

const assetRefreshStoragePrefix = 'ncg:asset-refresh:'

function recoveryKey(namespace, pathname) {
  return `${assetRefreshStoragePrefix}${namespace}:${pathname}`
}

export function buildAssetRefreshUrl(href, token = Date.now().toString(36)) {
  const url = new URL(href)
  url.searchParams.set(ASSET_REFRESH_QUERY, token)
  return url.toString()
}

export function waitForGameAssets(promise, namespace, timeoutMs = ASSET_LOAD_TIMEOUT_MS) {
  let timeoutId
  const timeout = new Promise((_, reject) => {
    timeoutId = window.setTimeout(() => {
      reject(new Error(`Timed out while loading assets for ${namespace}`))
    }, timeoutMs)
  })

  return Promise.race([promise, timeout]).finally(() => window.clearTimeout(timeoutId))
}

export function completeGameAssetLoad(namespace) {
  if (typeof window === 'undefined') return

  try {
    window.sessionStorage.removeItem(recoveryKey(namespace, window.location.pathname))
  } catch {
    // Storage can be unavailable in strict privacy modes. Loading still succeeded.
  }

  const url = new URL(window.location.href)
  if (!url.searchParams.has(ASSET_REFRESH_QUERY)) return
  url.searchParams.delete(ASSET_REFRESH_QUERY)
  window.history.replaceState(window.history.state, '', `${url.pathname}${url.search}${url.hash}`)
}

export function recoverGameAssetLoad(error, namespace) {
  if (typeof window === 'undefined') throw error

  const key = recoveryKey(namespace, window.location.pathname)
  let shouldRefresh = false
  try {
    if (!window.sessionStorage.getItem(key)) {
      window.sessionStorage.setItem(key, Date.now().toString())
      shouldRefresh = true
    }
  } catch {
    throw error
  }

  if (!shouldRefresh) throw error

  window.location.replace(buildAssetRefreshUrl(window.location.href))
  return new Promise(() => {})
}

export function forceGameAssetRefresh() {
  if (typeof window === 'undefined') return

  try {
    const keys = []
    for (let index = 0; index < window.sessionStorage.length; index += 1) {
      const key = window.sessionStorage.key(index)
      if (key?.startsWith(assetRefreshStoragePrefix)) keys.push(key)
    }
    keys.forEach((key) => window.sessionStorage.removeItem(key))
  } catch {
    // The cache-busting URL still forces the browser to request fresh HTML.
  }

  window.location.replace(buildAssetRefreshUrl(window.location.href))
}
